import apisauce from 'apisauce';

// constructor
const create = (baseURL = window.API_HOST) => {
    const api = apisauce.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 10000,
    });

    const searchTag = (keyword, pageSize = 8, pageNum = 1) => api.get(window.METADATA_API + 'catalogs/tags/search', {
        keyPhrasePrefix: keyword,
        pageSize,
        pageNum,
    });

    const searchCatalog = (keyword, pageSize = 8, pageNum = 1) => api.get(window.METADATA_API + 'catalogs/search', {
        key: keyword,
        pageSize,
        pageNum,
    });

    return {
        searchTag,
        searchCatalog,
    };
};


export default {
    create,
};
